export default [
    {
        name: "root",
        path: "/",
        component: () => import(/* webpackChunkName: "main" */ "@/tenant/NLS/view/apps/Main.vue"),
        meta: {
            layout: "NLSDefaultLayout",
            title: "NLS Canvas : Home",
            auth: false,
        },
    },
    {
        name: "canvas",
        path: "/canvas",
        component: () => import(/* webpackChunkName: "dot-canvas" */ /* webpackPrefetch: true */ "@/view/apps/DotCanvas.vue"),
        meta: {
            layout: "NLSWideLayout",
            title: "NLS Canvas : Canvas",
        },
    },
    {
        name: "cloud",
        path: "/cloud",
        component: () => import(/* webpackChunkName: "dot-cloud" */ "@/view/apps/DotCloud.vue"),
        meta: {
            layout: "NLSCloudLayout",
            title: "NLS Canvas: Drive",
        },
    },
]
